import {validations} from "./Validations";
import {Forms} from "../../../types/Forms";
import {
  QUOTE_EQUITY_LABELS as LABELS,
  QUOTE_EQUITY_OPTIONS as OPTIONS,
} from "./FormConfig";

const API_BASE_URL = `${window.location.origin}/wp-json/simulators/v1/quote-equity`;
const PROCESS_TYPE = 4;
const OPERATION_TYPE = 2;

let MIDDLEWARE_API_URL = API_BASE_URL;
const rootElement = document.querySelector(
  '[data-block="tool-block"]',
) as HTMLElement | null;
if (rootElement !== null) {
  const NEW_URL = rootElement.getAttribute("data-tool-managment");
  if (NEW_URL !== null && NEW_URL !== "") {
    MIDDLEWARE_API_URL = NEW_URL;
  }
}

export const forms: Forms = {
  quote_equity: {
    validation: validations.quote_equity,
    api: {
      url: MIDDLEWARE_API_URL,
      processType: PROCESS_TYPE,
      operationType: OPERATION_TYPE,
    },
    fields: [
      {
        type: "title",
        label: LABELS.title,
      },
      // "Preço do imóvel" and "Localização do imóvel" are paired into a
      // "group" field (rather than two standalone heading+input entries)
      // so they sit side by side on tablet, matching the codebase's
      // existing convention for this (see e.g. retirement-investment's
      // Form.tsx) — a bare "heading" field is always full-width, so two
      // of them in a row would otherwise force each input onto its own
      // line instead of pairing up.
      {
        type: "group",
        label: "",
        group_fields: [
          {
            type: "heading",
            label: LABELS.propertyValue,
          },
          {
            type: "number",
            label: "",
            name: "propertyValue",
            icon: "currency",
            placeholder: "200.000,00",
          },
        ],
      },
      {
        type: "group",
        label: "",
        group_fields: [
          {
            type: "heading",
            label: LABELS.region,
          },
          {
            type: "select",
            label: "",
            name: "region",
            options: OPTIONS.region,
            defaultValue: "MADRID",
          },
        ],
      },
      {
        type: "group",
        label: "",
        group_fields: [
          {
            type: "heading",
            label: LABELS.loanTermInYears,
          },
          {
            type: "number",
            label: "",
            name: "loanTermInYears",
            placeholder: "40",
          }
        ],
      },
      {
        type: "group",
        label: "",
        group_fields: [
          {
            type: "heading",
            label: LABELS.rateType,
          },
          {
            type: "select",
            label: "",
            name: "rateType",
            options: OPTIONS.rateType,
            defaultValue: "FIXED",
          },
        ],
      },
      {
        type: "heading",
        label: LABELS.condition,
      },
      {
        type: "radio",
        layout: "horizontal",
        label: LABELS.condition,
        name: "condition",
        options: OPTIONS.condition,
        defaultValue: "USADA",
      },
      {
        type: "heading",
        label: LABELS.monthlyNetIncome,
      },
      {
        type: "number",
        label: "",
        icon: "currency",
        name: "monthlyNetIncome",
        placeholder: "1.130,00",
      },
      {
        type: "hidden",
        label: "",
        name: "country",
        defaultValue: "ES",
      },
    ],
  },
};

export default forms;
